// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resource_desc ol{list-style:auto!important;padding:0 20px;margin:0 10px}.resource_desc ol li{padding-left:5px;list-style-type:decimal!important}.resource_desc ul{list-style:disc!important;padding:0 20px;margin:0 10px}.resource_desc ul li{list-style:disc!important;padding-left:5px}.resource_desc code{background-color:var(--mg-color-gray-300);padding:2px 6px;border-radius:3px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
